import React from "react";
import RadioHiddenInput from "./styled/RadioHiddenInput";
import RadioInputContainer from "./styled/RadioInputContainer";
import StyledRadioInput from "./styled/StyledRadioInput";
import { RadioLabelContainer } from "./styled/RadioLabel";
import TextType from "../Text/types/textTypes";
import { ColorType } from "../../styles";
import Text, { FontFamilyType } from "../Text";

export type RadioComponentProps = {
  checked: boolean;
  value: string;
  onChange: (value: string) => void;
  label: string;
  testId?: string;
  labelFontSize?: keyof typeof TextType;
  labelFontFamily?: FontFamilyType;
  labelColor?: ColorType;
  labelIcon?: JSX.Element | null;
  labelIconPosition?: "left" | "right";
  name?: string;
  description?: string;
  descriptionFontSize?: keyof typeof TextType;
  descriptionColor?: ColorType;
};

const RadioInput: React.FC<RadioComponentProps> = ({
  value,
  testId,
  checked,
  onChange,
  label,
  labelColor = "SLATE700",
  labelFontSize = "P14",
  labelFontFamily,
  labelIcon,
  labelIconPosition,
  name,
  description,
  descriptionFontSize = "P14",
  descriptionColor = "SLATE700",
}) => {
  return (
    <RadioInputContainer>
      <RadioHiddenInput readOnly checked={checked} name={name} type="radio" />
      <StyledRadioInput
        data-testid={testId}
        name={name}
        value={value}
        checked={checked}
        onClick={() => onChange(value)}
      />
      <RadioLabelContainer iconPosition={labelIconPosition}>
        {labelIcon && labelIcon}
        <div onClick={() => onChange(value)}>
          <Text
            type={labelFontSize}
            color={labelColor}
            data-testid={`${testId}-label`}
            checked={checked}
            name={name}
            fontFamily={labelFontFamily}
          >
            {label}
          </Text>
          {description && (
            <Text type={descriptionFontSize} color={descriptionColor}>
              {description}
            </Text>
          )}
        </div>
      </RadioLabelContainer>
    </RadioInputContainer>
  );
};

export default RadioInput;
